import { TipoSistemaExternoEnum } from 'graphql/types.generated'

export const tipoSistemaExternoRecord: Record<TipoSistemaExternoEnum, string> = {
  [TipoSistemaExternoEnum.ATENDIMENTO]: 'Atendimento',
  [TipoSistemaExternoEnum.MENU_LATERAL]: 'Menu lateral',
}

export const TIPOS_SISTEMA_EXTERNO = Object.keys(tipoSistemaExternoRecord) as TipoSistemaExternoEnum[]

export const tipoSistemaExternoToLabel = (tipo: TipoSistemaExternoEnum): string => tipoSistemaExternoRecord[tipo]
